import { Cents, formatMoney, toMoney } from '@betterment/core';

export function toFormattedMoney(value?: Cents) {
  if (value === undefined) {
    return 'unavailable';
  }

  return formatMoney(toMoney(value));
}
